export const METER = 1
export const KILOMETER = 1000
export const MILE = 1609.344
